import { render, staticRenderFns } from "./ConsultNoteTabsItems.vue?vue&type=template&id=724e5cb3&scoped=true"
import script from "./ConsultNoteTabsItems.vue?vue&type=script&lang=js"
export * from "./ConsultNoteTabsItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724e5cb3",
  null
  
)

export default component.exports